"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_service_1 = require("../../shared/service/http.service");
var store_1 = require("@angular-redux/store");
var find_http_error_1 = require("../../shared/error/find-http-error");
var Subject_1 = require("rxjs/Subject");
var appraisal_1 = require("../../shared/model/appraisal");
var return_reason_1 = require("../model/return-reason");
var save_http_error_1 = require("../../shared/error/save-http-error");
var http_request_builder_1 = require("../../core/http-request-builder");
var update_http_error_1 = require("../../shared/error/update-http-error");
var FileSaver = require("file-saver");
var page_info_1 = require("../../shared/model/page-info");
var file_service_1 = require("../../shared/service/file.service");
var AppraisalService = /** @class */ (function () {
    function AppraisalService(_httpService, _http, _fileService, _ngRedux) {
        this._httpService = _httpService;
        this._http = _http;
        this._fileService = _fileService;
        this._ngRedux = _ngRedux;
        this.SAVE = AppraisalService.APPRAISAL_END_POINT + "/save";
        this.UPDATE = AppraisalService.APPRAISAL_END_POINT + "/update";
        this.FIND_APPRAISALS = AppraisalService.APPRAISAL_END_POINT + "/findByFilter";
        this.FIND_RETURN_REASONS = AppraisalService.APPRAISAL_END_POINT + "/findReturnReasons";
        this.FIND_BY_ID = AppraisalService.APPRAISAL_END_POINT + "/find";
        this.FIND_PAGE_INFO = AppraisalService.APPRAISAL_END_POINT + "/findPageInfo";
        this.DOWNLOAD_APPRAISAL = AppraisalService.APPRAISAL_END_POINT + "/report";
        this.saveSubject = new Subject_1.Subject();
        this.save$ = this.saveSubject.asObservable();
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.pageInfoSubject = new Subject_1.Subject();
        this.pageInfo$ = this.pageInfoSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
        this.subscribeFileService();
    }
    AppraisalService.prototype.save = function (appraisal, files) {
        this.saveOrUpdate(this._httpService.post(this.SAVE, appraisal, appraisal_1.Appraisal, save_http_error_1.SaveHttpError), files);
    };
    AppraisalService.prototype.update = function (appraisal, files) {
        this.saveOrUpdate(this._httpService.put(this.UPDATE, appraisal, appraisal_1.Appraisal, update_http_error_1.UpdateHttpError), files);
    };
    AppraisalService.prototype.findAppraisals = function (pageNumber, pageSize) {
        var _this = this;
        this._ngRedux.select('appraisalFilter')
            .subscribe(function (filter) {
            _this.findByFilter(filter, pageNumber, pageSize);
            _this.findPageInfo(filter, pageSize);
        });
    };
    AppraisalService.prototype.findById = function (id) {
        var _this = this;
        this._httpService.get(this.FIND_BY_ID + "/" + id, appraisal_1.Appraisal, find_http_error_1.FindHttpError)
            .subscribe(function (appraisal) { return _this.findSubject.next(appraisal); }, function (error) { return _this.errorSubject.next(error); });
    };
    AppraisalService.prototype.findReturnReasons = function () {
        var _this = this;
        this._httpService.get(this.FIND_RETURN_REASONS, return_reason_1.ReturnReason, find_http_error_1.FindHttpError)
            .subscribe(function (returnReasons) { return _this.findSubject.next(returnReasons); }, function (error) { return _this.errorSubject.next(error); });
    };
    AppraisalService.prototype.downloadAppraisal = function (appraisal) {
        var _this = this;
        this._http.post(this.DOWNLOAD_APPRAISAL, appraisal)
            .subscribe(function (csv) {
            FileSaver.saveAs(new Blob([csv._body], { type: 'text/csv' }), 'laudo' + new Date().toDateString() + '.csv');
        }, function (error) { return _this.errorSubject.next(new find_http_error_1.FindHttpError('Erro ao baixar o arquivo!')); });
    };
    AppraisalService.prototype.saveOrUpdate = function (observable, files) {
        var _this = this;
        observable.subscribe(function (appraisalResult) { return _this.saveFiles(appraisalResult, files); }, function (error) {
            _this.errorSubject.next(error);
        });
    };
    AppraisalService.prototype.findPageInfo = function (filter, pageSize) {
        var _this = this;
        this._httpService.post(this.FIND_PAGE_INFO + "?pageSize=" + pageSize, filter, page_info_1.PageInfo, find_http_error_1.FindHttpError)
            .subscribe(function (pageInfo) { return _this.pageInfoSubject.next(pageInfo); }, function (error) { return _this.errorSubject.next(error); });
    };
    AppraisalService.prototype.findByFilter = function (filter, pageNumber, pageSize) {
        var _this = this;
        this._httpService.post(this.FIND_APPRAISALS + "?pageNumber=" + pageNumber + "&pageSize=" + pageSize, filter, Array, find_http_error_1.FindHttpError)
            .subscribe(function (appraisals) { return _this.findSubject.next(appraisals); }, function (error) { return _this.errorSubject.next(error); });
    };
    AppraisalService.prototype.saveFiles = function (appraisal, files) {
        this._fileService.saveAppraisalFiles(files, appraisal);
    };
    AppraisalService.prototype.subscribeFileService = function () {
        var _this = this;
        this._fileService.save$
            .subscribe(function () { return _this.saveSubject.next(); });
        this._fileService.error$
            .subscribe(function (error) { return _this.errorSubject.next(error); });
    };
    AppraisalService.ctorParameters = function () { return [{ type: http_service_1.HttpService }, { type: http_request_builder_1.HttpRequestBuilder }, { type: file_service_1.FileService }, { type: store_1.NgRedux }]; };
    AppraisalService.APPRAISAL_END_POINT = '/appraisal';
    return AppraisalService;
}());
exports.AppraisalService = AppraisalService;
//# sourceMappingURL=appraisal.service.js.map


// WEBPACK FOOTER //
// appraisal.service.js